module.exports = __webpack_public_path__ + "img/logo.e2b5a07c.svg";